import React from 'react';
import { RiskMeterFinancialDto } from '../../../../dtos/RiskMeterFinancialDto';
import { formatCurrency } from '../utils/currency';
import './RiskMeter.css';

interface FinancialSliceTooltipProps {
    financial?: RiskMeterFinancialDto | null;
    score: number | null;
}

// Mirrors SliceTooltip's shape so the financial ring explains itself the same way the phase and
// milestone slices do.
export default function FinancialSliceTooltip({ financial, score }: FinancialSliceTooltipProps) {
    if (score === null || !financial) {
        return <div style={{ padding: '8px' }}><b>Financial</b>: No financial data</div>;
    }

    const cellStyle = { padding: '4px 8px', textAlign: 'center' as const };
    const headerStyle = { ...cellStyle, backgroundColor: '#f7f7f7' };
    const rowLabelStyle = { ...cellStyle, fontWeight: 'bold' as const, textAlign: 'left' as const };
    const resultCellStyle = { ...cellStyle, textAlign: 'right' as const };
    const resultHeaderStyle = { ...headerStyle, textAlign: 'right' as const };

    return (
        <div style={{ padding: '8px', fontSize: '12px' }}>
            <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                <b>Financial</b>
                <b>Score: {score}</b>
            </div>

            <table style={{ width: '100%', borderCollapse: 'collapse', marginTop: '15px' }}>
                <tbody>
                    <tr style={{ height: '28px' }}>
                        <th style={headerStyle}></th>
                        <th style={headerStyle}>Available Funds</th>
                        <th style={headerStyle}>Required Budget</th>
                        <th style={resultHeaderStyle}>Result</th>
                    </tr>
                    <tr>
                        <td style={rowLabelStyle}>Ratio</td>
                        <td style={cellStyle}>{formatCurrency(financial.availableFunds)}</td>
                        <td style={cellStyle}>{formatCurrency(financial.projectRequiredBudget)}</td>
                        <td style={resultCellStyle}>{financial.ratio !== null ? financial.ratio.toFixed(2) : '-'}</td>
                    </tr>
                </tbody>
            </table>

            <table style={{ width: '100%', borderCollapse: 'collapse', marginTop: '15px' }}>
                <tbody>
                    <tr style={{ height: '28px' }}>
                        <th style={headerStyle}>Source of Funding</th>
                        <th style={resultHeaderStyle}>Amount</th>
                    </tr>
                    <tr>
                        <td style={{ ...cellStyle, textAlign: 'left' }}>C06 Award</td>
                        <td style={resultCellStyle}>{formatCurrency(financial.c06Award)}</td>
                    </tr>
                    {financial.fundingSources.map((source, index) => (
                        <tr key={index}>
                            <td style={{ ...cellStyle, textAlign: 'left' }}>{source.source}</td>
                            <td style={resultCellStyle}>{formatCurrency(source.amount)}</td>
                        </tr>
                    ))}
                    <tr style={{ fontWeight: 'bold' }}>
                        <td style={{ ...cellStyle, textAlign: 'left' }}>Available Funds</td>
                        <td style={resultCellStyle}>{formatCurrency(financial.availableFunds)}</td>
                    </tr>
                </tbody>
            </table>
        </div>
    );
}
